import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SidebarComponent from "./SidebarComponent.vue";
import { onMounted, reactive } from "vue";
import { getAvailableRoutes } from "@/service/user.service";
import { RootState } from "@/types/state.type";
import { useStore } from "vuex";
import securityService from "@/service/security.service";
import { AppType } from "@/types/app.type";
import { MenuItem } from "@/types/menuItem.type";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const items = reactive<MenuItem[]>([
  {
    icon: "el-icon el-icon-home fas",
    index: "/issue-monitoring", // Ahora apunta correctamente a Home.view.vue
    title: "menu.home",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-eye fas",
    index: "/issue-monitoring/samplingpoints",
    title: "menu.samplingPoints",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-file-export fas",
    index: "/issue-monitoring/list",
    title: "menu.new",
    disabled: false,
  },
]);

const store = useStore<RootState>();

onMounted(async () => {
  const canAdmin = securityService.canAccessToApp(AppType.ADMIN);
  const canSupport = securityService.canAccessToApp(AppType.SUPPORT);
  const canStations = securityService.canAccessToApp(AppType.STATIONS);
  const canProcessTracking = securityService.canAccessToApp(AppType.PROCESS_TRACKING);
  const canAccessIssueMonitoring = securityService.canAccessToApp(AppType.ISSUE_MONITORING);

  if (canAccessIssueMonitoring && !canSupport && !canStations && !canAdmin && !canProcessTracking) {
    items.shift();
  }
  if (store.state.auth.user?.id) {
    let userRoutes = await getAvailableRoutes(store.state.auth.user.id);

    if (userRoutes && Array.isArray(userRoutes) && userRoutes.length > 0) {
      // if (userRoutes) {
      items.forEach((item: MenuItem) => {
        item.disabled = !userRoutes.includes(item.index);
      });
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SidebarComponent, { items: _unref(items) }, null, 8, ["items"]))
}
}

})